/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import * as _ from 'lodash'
import dateFormat from 'dateformat'
import { isMobile } from 'react-device-detect'
import { FlatTournamentMatchInfo, MatchupStore, TournamentTrack } from '@store/matchupStore'
import { GlobalStore } from '@store/globalStore'
import { AuthStore } from '@store/authStore'
import { GAME_TYPE } from '@game-type/game-market-types'
import { ArrDayText, Mining } from '@game/util'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import {
  existExtraInningInfoVisibleSportId,
  isLsportsEnv,
  isSpecialMarket,
  noExistExtraInningInfoVisibleSportId,
} from '@utils/utils'
import {
  BANNER_POSITION_TYPE,
  LS_SPORTS_TYPE_NUM,
  PAGE_TYPE,
  SPORTS_TYPE,
  SPORTS_TYPE_NUM,
} from '@interface/common'
// icon
import LiveSoccerBg from '@assets/images/bg/match/soccer.jpg'
import LiveBasketballBg from '@assets/images/bg/match/basketball.jpg'
import LiveBaseballBg from '@assets/images/bg/match/baseball.jpg'
import LiveVolleyballBg from '@assets/images/bg/match/volleyball.jpg'
import LiveIceHokeyBg from '@assets/images/bg/match/ice_hockey.jpg'
import LiveTableTennisBg from '@assets/images/bg/match/table_tennis.jpg'
import LiveDefaultBg from '@assets/images/bg/match/common_sports.jpg'
import { ChangeMatchIco } from '@shared/Icon/MatchupIcon'
import FavoriteImg from '@assets/images/btn/favorite-manage.png'
import FavoriteImgGray from '@assets/images/btn/favorite-manage-gray.png'
import FavoriteActiveImg from '@assets/images/btn/favorite-manage-active.png'
import FavoriteAllImg from '@assets/images/btn/favorite-manage-all.png'
import FavoriteAllActiveImg from '@assets/images/btn/favorite-manage-all-active.png'
import LeagueEmblemImg from '@assets/images/icon/emblem_icon/league.png'
import HotTagIco from '@assets/images/icon/matchup_icon/hot-tag-ico.png'
import HotTagResultIco from '@assets/images/icon/matchup_icon/hot-tag-result-ico.png'
// css
import { MatchWrapper } from '@styles/match.style'
import { TxtLimit } from '@styles/base.style'
import { Button } from '@styles/button.style'
import MatchUpButton from '@views/Matchup/MatchUpDetail/MatchUpButton'
import { LogStore } from '@store/logStore'
import { MATCHUP_DETAIL_CONTENT_TAB_KEY, MATCHUP_DETAIL_STATIC_FILTER_INDEX } from '@constants/index'
import { CircleDownIco } from '@shared/Icon/ArrowIcon'
import { IFavoriteMatch, Schema$TournamentTrack } from '@protocol/game'
import { LS_MATCH_STATUS, MATCH_STATUS } from 'adv-protocol/src/GameCommon'
import { EXCEPTIONAL_UNIQUE_ID } from '@v2/constants/common'
// import AdvCasinoMatchupBannerImg from '@assets/images/casino/banner/casino-matchup-banner.png'
// import AdvCasino from '@views/AdvCasino'
import { CompanyPickStore } from '@store/companyPickStore'
import OddsBlock, { BLOCK_TYPE } from './OddsBlock'
import { UserPickStore } from '@store/userPickStore'
// import StatVisualizationButton from '@components/Button/StatVisualizationButton'
import classNames from 'classnames'
import { BASIC_TEAM_EMBLEM_MAP } from '@shared/EmblemGroup'
import { UserPickPromotionBanner } from '@views/Home/UserPick/Components/UserPickPromotionBanner'
import MatchUpListBanner from '@views/Matchup/MatchUpListBanner'
import { SPORT_TALK_PREVIEW_TYPE } from '@v2/constants/sport-issue'
import SportTalkIssuePreview from '../SportTalkIssuePreview'
import PopupUtils from '@utils/popup-utils'
import DialogUtils from '@utils/dialog-utils'

function getSymbolIco(e) {
  e.target.src = LeagueEmblemImg
}

export interface MatchBlockProps {
  rowIndex: string
  pageType: PAGE_TYPE
  track: TournamentTrack
  gameType: GAME_TYPE
  matchupStore: MatchupStore
  globalStore: GlobalStore
  logStore: LogStore
  authStore: AuthStore
  routerStore: RouterStore
  companyPickStore: CompanyPickStore
  onFieldClickCheck?: () => boolean
  visibleBanner: boolean
  userPickStore: UserPickStore
  minimumLiveMatchOutcomeRate: number
}

const FAVORITE_BUTTON_CLASS = 'odds-block-list--btn sub-btn favorite-btn'
const FAVORITE_ACTIVE_CLASS = 'active'
const FAVORITE_NUM_CLASS = 'favorite-tab'
const FAVORITE_BTN_ACTIVE_ANI_CLASS = 'ani'
const FAVORITE_ANIMATION_STOP_DELAY = 550
const FavoriteBtn = <img src={FavoriteImg} className="favorite-btn-img" alt="favorite-btn"/>
const FavoriteBtnGray = <img src={FavoriteImgGray} className="favorite-btn-img" alt="favorite-btn"/>
const FavoriteActiveBtn = <img src={FavoriteActiveImg} className="favorite-btn-active-img" alt="favorite-btn-active"/>
const FavoriteAllBtn = <img src={FavoriteAllImg} className="favorite-btn-img" alt="favorite-btn"/>
const FavoriteAllActiveBtn = <img src={FavoriteAllActiveImg} className="favorite-btn-active-img" alt="favorite-btn"/>

const TOP_BANNER_ORDER = 0

class MatchBlock extends React.Component<MatchBlockProps> {
  private readonly track: Schema$TournamentTrack

  private readonly matchupStore: MatchupStore

  private readonly globalStore: GlobalStore

  private readonly logStore: LogStore

  private readonly authStore: AuthStore

  private readonly routerStore: RouterStore

  private readonly companyPickStore: CompanyPickStore

  private readonly userPickStore: UserPickStore

  constructor(props: MatchBlockProps) {
    super(props)
    this.track = props.track
    this.matchupStore = props.matchupStore
    this.globalStore = props.globalStore
    this.logStore = props.logStore
    this.authStore = props.authStore
    this.routerStore = props.routerStore
    this.companyPickStore = props.companyPickStore
    this.userPickStore = props.userPickStore
    this.logStore = props.logStore
  }

  onClickTournament = () => {
    // if (pageType === PAGE_TYPE.MATCHUP_RESULT) {
    //   const { tournamentId } = this.track
    //   this.matchupStore.onClickMatchupPopupFilter(tournamentId)
    //
    //   return
    // }

    // 팝업 호출 시 강제로 body에 overflow: hidden이 적용되기 때문에 추가
    // --> PC버전에서 페이지 형태의 팝업이기때문에 좌우 스크롤이 가능해야함
    // const bodyXScrollable = 'body-x-scrollable'
    //
    // const { body } = document
    // const { classList } = body
    //
    // if (!isMobile) {
    //   classList.add(bodyXScrollable)
    // }
    this.matchupStore.setMatchupListState()
    this.globalStore.setVisibleMatchFilterPopup(true)
    this.matchupStore.setTournamentFilterList([this.track.tournamentId])
  }

  setFavoriteMatchList = async (isFavoriteAll: boolean) => {
    await this.matchupStore.toggleFavoriteMatchList(this.track, isFavoriteAll)

    this.matchupStore.fetchFavoriteTotalPreMatchCount().catch(err => console.error(err))
    this.matchupStore.updateIsTournamentFavoriteInTournamentTrack(this.track)

    const { matches } = this.track
    this.matchupStore.updateIsFavoriteMatchByMatchTracks(matches, isFavoriteAll)
    _.forEach(matches, match => {
      this.companyPickStore.updateNoticeCompanyPicksFavoriteMatchInfo(match.matchId, isFavoriteAll)
    })
  }

  onClickTournamentFavorite = async () => {
    if (!this.authStore.isSignedIn) {
      return
    }

    const { isTournamentFavorite } = this.track
    await this.setFavoriteMatchList(!isTournamentFavorite)
  }

  makeHeader = () => {
    const { gameType, pageType } = this.props
    const { sportId, categoryName, tournamentName, tournamentEmblem, isTournamentFavorite } = this.track

    let filterArrowIco: React.ReactElement
    if (pageType === PAGE_TYPE.MATCHUP_RESULT
      || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
      || gameType === GAME_TYPE.CROSS) {
      filterArrowIco = <CircleDownIco/>
    } else {
      filterArrowIco = <Fragment/>
    }

    const filterItem = (
      <Fragment>
        {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[sportId] : SPORT_ID_ICON_MAP[sportId]}
        {categoryName}
        <img src={tournamentEmblem || LeagueEmblemImg} alt="리그" className="tournament-emblem" onError={getSymbolIco}/>
        {tournamentName}
      </Fragment>
    )
    const tournamentItem = (
      <Fragment>
        {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[sportId] : SPORT_ID_ICON_MAP[sportId]}
        {categoryName}
        <img src={tournamentEmblem || LeagueEmblemImg} alt="리그" className="tournament-emblem" onError={getSymbolIco}/>
        {tournamentName}
      </Fragment>
    )

    const favoriteTournamentElem = (
      <Fragment>
        <div className="tournament-wrap filter">
          {filterItem}
        </div>
        {this.track ? <span className="tournament-match-count">({this.track.matchCount})</span> : <Fragment/>}
        {/* 리그필터 - 전체 찜 */}
        {/* 활성화 되었을 시 'active' class 추가 */}
        <Button TP className={isTournamentFavorite ? 'favorite-all-btn active' : 'favorite-all-btn'}
                onClick={this.onClickTournamentFavorite}>
          {FavoriteAllBtn}
          {FavoriteAllActiveBtn}
        </Button>
      </Fragment>
    )

    const basicAndMatchCountTournamentElem = (
      <Fragment>
        <div className="tournament-wrap">
          {tournamentItem}
        </div>
        {this.track ? <span className="tournament-match-count">({this.track.matchCount})</span> : <Fragment/>}
      </Fragment>
    )

    const leagueFilterTournamentElem = (
      <Button TP onClick={this.onClickTournament} className="tournament-wrap">
        {tournamentItem}
        {filterArrowIco}
      </Button>
    )

    const basicTournamentElem = (
      <div className="tournament-wrap">
        {tournamentItem}
      </div>
    )

    let tournamentElem: React.ReactElement
    if (pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      tournamentElem = basicAndMatchCountTournamentElem
    } else if (pageType === PAGE_TYPE.MATCHUP_RESULT) {
      tournamentElem = leagueFilterTournamentElem
    } else if (gameType === GAME_TYPE.CROSS) {
      if (pageType === PAGE_TYPE.MATCHUP_FILTER) {
        tournamentElem = favoriteTournamentElem
      } else {
        tournamentElem = leagueFilterTournamentElem
      }
    } else {
      tournamentElem = basicTournamentElem
    }

    let isVisibleExtraInningInfo: string
    let isVisibleNoExtraInningInfo: string

    if (gameType !== GAME_TYPE.LIVE
      && gameType !== GAME_TYPE.SPECIAL) {
      isVisibleExtraInningInfo = existExtraInningInfoVisibleSportId(sportId)
      isVisibleNoExtraInningInfo = noExistExtraInningInfoVisibleSportId(sportId)
    }

    return (
      <div className="tournament-info">
        {tournamentElem}

        {isVisibleExtraInningInfo && <span className="extra-inning">연장포함</span>}
        {isVisibleNoExtraInningInfo && <span className="no-extra-inning">연장미포함</span>}
      </div>
    )
  }

  makeBanner = () => {
    // 기획 변경으로 사용하지 않는 이벤트헨들러입니다. [이슈링크](https://task.zempublic.co.kr/view.php?id=9841)
    // const onClickAdvCasinoHandler = () => {
    //   if (isMobile) {
    //     loadOrReload.push('/advCasino')
    //   } else {
    //     this.globalStore.addGeneralPopupProperties(<AdvCasino/>, '승부사카지노', {
    //       wrapClassName: '',
    //       className: 'adv-casino',
    //       isScroll: true,
    //       custom: false,
    //       clsBtn: false,
    //     })
    //   }
    // }

    return (
      <MatchUpListBanner/>
    )
  }

  makeMatchBlockChildren = (): React.ReactElement[] => {
    const { track, onFieldClickCheck, gameType, pageType, minimumLiveMatchOutcomeRate } = this.props
    const { currentSportsKey } = this.matchupStore
    const { matches = [], sportId, tournamentId } = track
    const panelChildren = []
    let matchCount = 1
    for (const match of matches) {
      const {
        matchStatusCode,
        regulars,
        isFavorite,
        companyPickCount,
        userPickCount,
        showUserPickPromotionBanner,
        dateOfMatch,
        // homeTeamId,
        // awayTeamId,
        homeTeamName,
        awayTeamName,
        homeTeamEmblem,
        awayTeamEmblem,
        matchId,
        // hasCheerForTeam,
        isHotMatch,
        sportTalkPreview,
      } = match
      if (gameType === GAME_TYPE.LIVE) {
        if (isLsportsEnv()) {
          switch (matchStatusCode) {
            case LS_MATCH_STATUS.ABANDONED:
            case LS_MATCH_STATUS.COVERAGE_LOST:
            case LS_MATCH_STATUS.FULL_TIME:
            case LS_MATCH_STATUS.FULL_TIME_AFTER_OVERTIME:
            case LS_MATCH_STATUS.FULL_TIME_AFTER_PENALTIES:
              continue
          }
        } else {
          if (matchStatusCode === MATCH_STATUS.AOT || matchStatusCode === MATCH_STATUS.AP) {
            continue
          }
          /**
           * Abandoned = 90,
           * Walkover = 91,
           * Retired = 92,
           * Walkover_Player1Won = 93,
           * Walkover_Player2Won = 94,
           * Player1Retired_Player2Won = 95,
           * Player2Retired_Player1Won = 96,
           * Player1Defaulted_Player2Won = 97,
           * Player2Defaulted_Player1Won = 98,
           * OnlyResult = 99,
           * Ended = 100,
           * AET = 110,
           * AOT = 111, After OverTime
           * AP = 120, After Penalties
           */
          if (matchStatusCode >= MATCH_STATUS.Abandoned && matchStatusCode <= MATCH_STATUS.Ended) {
            continue
          }
        }
      }
      let oddsCount = 1
      let matchUpClassName = 'match-up'
      const oddsBlockList = []
      const componentKey = `MatchBlock_match_${match.id}`
      if (gameType === GAME_TYPE.LIVE && _.isEmpty(match.regulars)) {
        oddsBlockList.push(
          <span key={`MatchBlock_span_${match.id}`} className={matchUpClassName}>
            <OddsBlock
              gameType={gameType}
              pageType={pageType}
              key={`MatchBlock_span_${match.id}_odds_block`}
              track={track}
              match={match}
              blockType={BLOCK_TYPE.LIVE}
              onFieldClickCheck={onFieldClickCheck}
              minimumLiveMatchOutcomeRate={minimumLiveMatchOutcomeRate}
            />
          </span>,
        )
      }

      if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
        oddsBlockList.push(
          <span key={`MatchBlock_span_${match.id}`} className={matchUpClassName}>
            <OddsBlock
              gameType={gameType}
              pageType={pageType}
              key={`MatchBlock_span_${match.id}_result`}
              track={track}
              match={match}
              blockType={BLOCK_TYPE.LIVE}
              minimumLiveMatchOutcomeRate={minimumLiveMatchOutcomeRate}
            />
          </span>,
        )
      } else {
        for (const marketTrack of regulars) {
          const ukey = `MatchBlock_span_${marketTrack.id}`
          const marketType = marketTrack.type

          if (matchCount > 1 && oddsCount === 1) {
            matchUpClassName += ' first'
          } else {
            matchUpClassName = 'match-up'
          }

          let oddsBlockKey: string
          let blockType: BLOCK_TYPE
          if (Mining.isRegularOutcomeWay(marketType) === true) {
            oddsBlockKey = `${ukey}_wdl`
            blockType = BLOCK_TYPE.WDL
            if (gameType === GAME_TYPE.LIVE) {
              blockType = BLOCK_TYPE.LIVE
            }
          } else if (Mining.isRegularOutcomeHandicap(marketType) === true) {
            oddsBlockKey = `${ukey}_handicap`
            blockType = BLOCK_TYPE.HANDICAP
          } else if (Mining.isRegularOutcomeUnderOver(marketType) === true) {
            oddsBlockKey = `${ukey}_underover`
            blockType = BLOCK_TYPE.UNDEROVER
          } else if (isSpecialMarket(marketType)) {
            oddsBlockKey = `${ukey}_special`

            const sampleMarket = marketTrack.markets[0]
            if (sampleMarket.specifiers?.hcp != null) {
              blockType = BLOCK_TYPE.HANDICAP
            } else if (sampleMarket.specifiers?.total != null) {
              blockType = BLOCK_TYPE.UNDEROVER
            } else {
              blockType = BLOCK_TYPE.WDL
            }
          }

          oddsBlockList.push(
            <span id={ukey} key={ukey} className={matchUpClassName}>
            <OddsBlock
              gameType={gameType}
              pageType={pageType}
              key={oddsBlockKey}
              track={track}
              match={match}
              marketTrack={marketTrack}
              marketType={marketType}
              blockType={blockType}
              onFieldClickCheck={onFieldClickCheck}
              minimumLiveMatchOutcomeRate={minimumLiveMatchOutcomeRate}
            />
          </span>,
          )
          oddsCount += 1
        }
      }

      const dateAt = dateFormat(dateOfMatch, 'mm/dd')
      const dayAt = ArrDayText[new Date(dateOfMatch).getDay()]
      const timeAt = dateFormat(dateOfMatch, 'HH:MM')
      const dateText = `${dateAt}(${dayAt}) `
      const timeText = ` ${timeAt}`

      let matchGroupBgImage: any
      switch (sportId) {
        case LS_SPORTS_TYPE_NUM.SOCCER:
        case SPORTS_TYPE_NUM.SOCCER:
          matchGroupBgImage = LiveSoccerBg
          break
        case LS_SPORTS_TYPE_NUM.BASKETBALL:
        case SPORTS_TYPE_NUM.BASKETBALL:
          matchGroupBgImage = LiveBasketballBg
          break
        case LS_SPORTS_TYPE_NUM.BASEBALL:
        case SPORTS_TYPE_NUM.BASEBALL:
          matchGroupBgImage = LiveBaseballBg
          break
        case LS_SPORTS_TYPE_NUM.ICE_HOCKEY:
        case SPORTS_TYPE_NUM.ICE_HOCKEY:
          matchGroupBgImage = LiveIceHokeyBg
          break
        case LS_SPORTS_TYPE_NUM.VOLLEYBALL:
        case SPORTS_TYPE_NUM.VOLLEYBALL:
          matchGroupBgImage = LiveVolleyballBg
          break
        case SPORTS_TYPE_NUM.TABLE_TENNIS:
          matchGroupBgImage = LiveTableTennisBg
          break
        default:
          matchGroupBgImage = LiveDefaultBg
          break
      }

      let oddsBlockListContentClassName = 'odds-block-list-content'
      switch (matchStatusCode) {
        case MATCH_STATUS.NotStarted:
        case MATCH_STATUS.Postponed:
        case MATCH_STATUS.StartDelayed:
        case MATCH_STATUS.Cancelled:
        case MATCH_STATUS.Suspended:
          oddsBlockListContentClassName += ' before'
          break
      }
      if (isLsportsEnv()) {
        switch (matchStatusCode) {
          case LS_MATCH_STATUS.NOT_STARTED:
          case LS_MATCH_STATUS.NOT_START_YET:
          case LS_MATCH_STATUS.POSTPONED:
          case LS_MATCH_STATUS.ABOUT_TO_START:
          case LS_MATCH_STATUS.CANCELLED:
          case LS_MATCH_STATUS.INTERRUPTED:
            oddsBlockListContentClassName += ' before'
            break
        }
      }
      if (currentSportsKey === SPORTS_TYPE.HOT) {
        oddsBlockListContentClassName += ' hot'
      }

      const onClickChangeMatch = () => {
        const { detailTrack } = this.matchupStore
        if (!detailTrack) {
          return
        }

        DialogUtils.showChangeMatch({
          currentGameKey: gameType,
          imageSrc: track.tournamentEmblem || LeagueEmblemImg,
          tournamentName: track.tournamentName,
        })
      }

      // 상세 BET sub button
      function SubBtn() {
        return (
          pageType !== PAGE_TYPE.MATCHUP_RESULT && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER &&
          (<Button className="change-match-btn" onClick={onClickChangeMatch}><ChangeMatchIco/></Button>)
        )
      }

      const showMatchupDetail = async (initialTabIndex = MATCHUP_DETAIL_STATIC_FILTER_INDEX.TOTAL) => {
        this.globalStore.setMatchupDetailTabInitialIndex(initialTabIndex)
        const { producerId, club, gameKey } = this.matchupStore

        let isFetchedMatchupDetail = false
        if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
          this.matchupStore.setDetailTrack(tournamentId, match, pageType)
          isFetchedMatchupDetail = true
        } else {
          isFetchedMatchupDetail = await this.matchupStore.fetchMatchupDetailMarkets({
            gameType: gameKey, clubId: club?.id, producerId, matchId, tournamentId: track.tournamentId,
          })
        }

        if (isMobile && isFetchedMatchupDetail) {
          let title = '상세 BET'
          if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
            title = '경기결과'
          }

          this.globalStore.setVisibleMatchupDetailPopup(true)
          PopupUtils.showMatchUpDetail(title, () => {
            switch (gameKey) {
              case GAME_TYPE.CROSS:
                this.logStore.writeButtonLog({ pageId: 'b050', buttonId: '001' }).catch(console.error)
                break
              case GAME_TYPE.LIVE:
                this.logStore.writeButtonLog({ pageId: 'b060', buttonId: '001' }).catch(console.error)
                break
            }
            this.globalStore.setVisibleMatchupDetailPopup(false)
          }, <SubBtn/>)
          setTimeout(() => {
            // 상세 BET(상세경기) 지목을 위한 className
            const htmlElem = document.getElementsByTagName('html')[0]
            htmlElem.classList.add('matchup')
          }, 1)
        }
      }

      const updateMatchFavorite = (isAdded: boolean): void => {
        let isRemoveMatchIdSameDetailTrackMatchId = false

        if (!isAdded) {
          isRemoveMatchIdSameDetailTrackMatchId = matchId === this.matchupStore.detailTrack?.track.matchId
          // 찜 탭인 경우 트랙 리스트에서 제거 되어야 한다.
          if (this.matchupStore.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH) {
            this.matchupStore.removeTrackInTracksByMatchId(matchId)
          }
        }

        const element = document.querySelector(`#matchFavoriteBtn_${matchId}`)

        if (!_.isNil(isAdded)) {
          this.matchupStore.updateIsFavoriteMatchByMatchTracks([match], isAdded)

          if (isAdded) {
            this.matchupStore.increaseFavoriteMatchCount()
            this.matchupStore.increaseFavoriteTotalPreMatchCount()
            this.matchupStore.addFavoriteMatchId(matchId)
            if (pageType !== PAGE_TYPE.MATCHUP_FILTER
              && this.matchupStore.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH) {
              // 분석글 팝업에서 찜을 해제 후 팝업을 닫지 않고 다시 찜을 누르면 찜매치 목록이 갱신되어야 하기 때문에.
              this.matchupStore.fetchTournamentTracks({
                limit: 20, reset: true, pageType,
              }).catch(err => console.error(err))
            }
            if (element) {
              // 찜 탭 +1
              addFavoriteStyle(element)
              showFavoriteNumAnimation()
              // 찜 버튼
              addFavoriteBtnStyle(element)
              showFavoriteBtnAnimation(element)
            }
          } else {
            this.matchupStore.decreaseFavoriteMatchCount()
            this.matchupStore.decreaseFavoriteTotalPreMatchCount()
            this.matchupStore.removeFavoriteMatchId(matchId)
            if (element) {
              removeFavoriteStyle(element)
              removeFavoriteBtnStyle(element)
            }

            const { majorUniqueID, tracks, gameKey, club, producerId } = this.matchupStore

            if (!isMobile && pageType !== PAGE_TYPE.MATCHUP_FILTER
              && majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH) {
              if (_.isEmpty(tracks)) {
                this.matchupStore.resetDetailTrack()
              } else if (isRemoveMatchIdSameDetailTrackMatchId) {
                const track = _.head(tracks)
                const matchTrack = _.head(track.matches)
                if (pageType === PAGE_TYPE.MATCHUP_RESULT) {
                  this.matchupStore.setMatchupDetailContentTabKey(MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK)
                  this.matchupStore.setDetailTrack(track.tournamentId, matchTrack, pageType)
                } else {
                  this.matchupStore.setMatchupDetailContentTabKey(MATCHUP_DETAIL_CONTENT_TAB_KEY.BET)
                  this.matchupStore.fetchMatchupDetailMarkets({
                    gameType: gameKey,
                    clubId: club?.id,
                    producerId: producerId,
                    matchId: matchTrack.matchId,
                    tournamentId: track.tournamentId,
                  }).catch(console.error)
                }
              }
            }
          }

          this.companyPickStore.updateNoticeCompanyPicksFavoriteMatchInfo(matchId, isAdded)
          this.matchupStore.fetchFavoriteTotalPreMatchCount().catch(err => console.error(err))
          this.matchupStore.updateIsTournamentFavoriteInTournamentTrack(this.track)
        }
      }

      const onClickFavoriteMatch = async () => {
        if (!this.authStore.isSignedIn) {
          return
        }

        const params: IFavoriteMatch.Params = { matchId, sportId, dateOfMatch }

        const isAdded = await this.matchupStore.toggleFavoriteMatch(params)
        updateMatchFavorite(isAdded)
      }

      const showSportTalkInMatchDetail = ()=> {
        this.matchupStore.setMatchupDetailContentTabKey(MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK)
        showMatchupDetail().catch(console.error)
      }

      // 찜 탭 +1
      const showFavoriteNumAnimation = () => {
        startFavoriteNumAnimation()
        setTimeout(() => {
          stopFavoriteNumAnimation()
        }, FAVORITE_ANIMATION_STOP_DELAY)
      }

      const startFavoriteNumAnimation = () => {
        const elements = document.getElementsByClassName(FAVORITE_NUM_CLASS)
        _.forEach(elements, element => {
          if (!_.includes(element.classList, FAVORITE_ACTIVE_CLASS)) {
            element.classList.add(FAVORITE_ACTIVE_CLASS)
          }
        })
      }

      const stopFavoriteNumAnimation = () => {
        const elements = document.getElementsByClassName(FAVORITE_NUM_CLASS)
        _.forEach(elements, element => {
          element.classList.remove(FAVORITE_ACTIVE_CLASS)
        })
      }

      const addFavoriteStyle = (element: Element) => {
        if (!_.includes(element.classList, FAVORITE_ACTIVE_CLASS)) {
          element.classList.add(FAVORITE_ACTIVE_CLASS)
        }
      }

      const removeFavoriteStyle = (element: Element) => {
        element.classList.remove(FAVORITE_ACTIVE_CLASS)
      }

      // 찜 버튼
      const showFavoriteBtnAnimation = (e: Element) => {
        startFavoriteBtnAnimation(e)
        setTimeout(() => {
          stopFavoriteBtnAnimation(e)
        }, FAVORITE_ANIMATION_STOP_DELAY)
      }

      const startFavoriteBtnAnimation = (e: any) => {
        const elements = e.currentTarget
        _.forEach(elements, element => {
          if (!_.includes(element.classList, FAVORITE_BTN_ACTIVE_ANI_CLASS)) {
            element.classList.add(FAVORITE_BTN_ACTIVE_ANI_CLASS)
          }
        })
      }

      const stopFavoriteBtnAnimation = (e: any) => {
        const elements = e.currentTarget
        _.forEach(elements, element => {
          element.classList.remove(FAVORITE_BTN_ACTIVE_ANI_CLASS)
        })
      }

      const addFavoriteBtnStyle = (element: Element) => {
        if (!_.includes(element.classList, FAVORITE_BTN_ACTIVE_ANI_CLASS)) {
          element.classList.add(FAVORITE_BTN_ACTIVE_ANI_CLASS)
        }
      }

      const removeFavoriteBtnStyle = (element: Element) => {
        element.classList.remove(FAVORITE_BTN_ACTIVE_ANI_CLASS)
      }

      // const isShowStatVisualizationButton = () => {
      //   if (gameType === GAME_TYPE.LIVE) {
      //     return false
      //   }
      //
      //   if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      //     return false
      //   }
      //
      //   const displayEnabled
      //     = this.globalStore.findGlobalSetting(GlobalStoreKey.STAT_VISUALIZATION_BUTTON_DISPLAY_ENABLED)?.value === '1'
      //   if (!displayEnabled) {
      //     return false
      //   }
      //
      //   if (_.isEmpty(_.toString(seasonId))) {
      //     const displayEnabledWhenEmptySeasonId = this.globalStore.findGlobalSetting(
      //       GlobalStoreKey.STAT_VISUALIZATION_BUTTON_DISPLAY_ENABLED_WHEN_EMPTY_SEASON_ID)?.value === '1'
      //     if (!displayEnabledWhenEmptySeasonId) {
      //       return false
      //     }
      //   }
      //
      //   return true
      // }

      // const isCheerForTeam = (): boolean => {
      //   if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      //     return true
      //   }
      //
      //   return hasCheerForTeam
      // }

      let subButtonClassName = 'odds-block-list--btn sub-btn pick-btn-wrap'
      if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER){
        subButtonClassName = 'odds-block-list--btn sub-btn pick-btn-wrap result-page'
      }

      const isSportTalkPreview = !!sportTalkPreview

      const matchGroup = (
        // 경기 시작전일 경우 odds-block-list-content에 before를 추가해야합니다.
        <div key={componentKey} className={oddsBlockListContentClassName}>
          {/* *** 라이브 매치 뒷배경 *** */}
          <img src={matchGroupBgImage} alt="라이브 매치업 배경" className="live-match-bg"/>
          <div className="odds-block-list--header">
            {(isHotMatch && currentSportsKey !== SPORTS_TYPE.HOT) && (
              <span
                className={pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
                  ? 'odds-block-list--hot-icon result' : 'odds-block-list--hot-icon'}>
                <img
                  src={pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
                      ? HotTagResultIco : HotTagIco}
                alt="hot경기 아이콘" loading="lazy"/></span>)}
            <span className="odds-block-list--date">{dateText}</span>
            <span className="odds-block-list--time">{timeText}</span>

            {/*TODO: 매치업 내 랭킹 이벤트에 적용되는 경기 강조 이미지*/}
            {this.track.isEventLeague && this.globalStore.getRankingImages()?.matchListTagImage && (
              <img
                src={this.globalStore.getRankingImages().matchListTagImage}
                alt="이벤트 리그"
                style={{ height: '25px', marginLeft: '8px', marginBottom: '8px', }}
              />
            )}

            {pageType !== PAGE_TYPE.MATCHUP_RESULT
              && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER
              && gameType !== GAME_TYPE.SPECIAL && (
                <MatchUpButton
                  isDetail={true}
                  matchIndex={matchCount}
                  rowIndex={this.props.rowIndex}
                  tournamentId={tournamentId}
                  track={track}
                  match={match}
                  pageType={pageType}
                  onFieldClickCheck={onFieldClickCheck}
                  showMatchupDetail={showMatchupDetail}
                />
              )}
            {/* 기획 변경으로 매치정보 버튼 출력 중단 */}
            {/*<MatchUpButton*/}
            {/*  isStatVisualization={isShowStatVisualizationButton()}*/}
            {/*  matchIndex={matchCount}*/}
            {/*  rowIndex={this.props.rowIndex}*/}
            {/*  tournamentId={tournamentId}*/}
            {/*  track={track}*/}
            {/*  match={match}*/}
            {/*  pageType={pageType}*/}
            {/*  onFieldClickCheck={onFieldClickCheck}*/}
            {/*  showMatchupDetail={showMatchupDetail}*/}
            {/*/>*/}
            <MatchUpButton
              isCheerForTeam={true}
              matchIndex={matchCount}
              rowIndex={this.props.rowIndex}
              tournamentId={tournamentId}
              track={track}
              match={match}
              pageType={pageType}
              onFieldClickCheck={onFieldClickCheck}
              showMatchupDetail={showMatchupDetail}
            />
            {(companyPickCount > 0 || userPickCount > 0) &&
              <Button TP className={subButtonClassName}>
                <MatchUpButton
                  isPick={companyPickCount > 0 || userPickCount > 0}
                  matchIndex={matchCount}
                  rowIndex={this.props.rowIndex}
                  tournamentId={tournamentId}
                  track={track}
                  match={match}
                  pageType={pageType}
                  onFieldClickCheck={onFieldClickCheck}
                  showMatchupDetail={showMatchupDetail}
                >
                </MatchUpButton>
                {showUserPickPromotionBanner &&
                  <UserPickPromotionBanner bottom/>
                }
              </Button>
            }


          </div>

          <div className="odds-block-list--body">
            {gameType === GAME_TYPE.CROSS
              && pageType !== PAGE_TYPE.MATCHUP_RESULT
              && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER
              && <div className="odds-block-list--body--pattern"/>}
            {gameType === GAME_TYPE.LIVE
            || pageType === PAGE_TYPE.MATCHUP_RESULT
            || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER ? null : (
              <div className="odds-block-list--team-info">
                {/*<img src={HomeLabel} alt="홈" className="odds-block-list--team-info--home"/>*/}
                <span className="odds-block-list--team-info--name" css={TxtLimit}>
                  <img
                    src={homeTeamEmblem || BASIC_TEAM_EMBLEM_MAP[sportId]}
                    alt="home team emblem"
                    className="odds-block-list--team-info--emblem"
                  />
                  {homeTeamName}
                </span>
                <span className="odds-block-list--team-info--vs">vs</span>
                <span className="odds-block-list--team-info--name" css={TxtLimit}>
                  <img
                    src={awayTeamEmblem || BASIC_TEAM_EMBLEM_MAP[sportId]}
                    alt="away team emblem"
                    className="odds-block-list--team-info--emblem"
                  />
                  {awayTeamName}
                </span>
              </div>
            )}
            {oddsBlockList}
            {pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER && (
              <Button id={`matchFavoriteBtn_${matchId}`}
                      className={`${FAVORITE_BUTTON_CLASS} ${isFavorite ? FAVORITE_ACTIVE_CLASS : ''}`}
                      onClick={() => {
                        onClickFavoriteMatch()
                      }}>
                <span className="favorite-pulse"/>
                <span className="favorite-pulse pulse-2"/>
                {pageType === PAGE_TYPE.MATCHUP_RESULT ? FavoriteBtnGray : FavoriteBtn}
                {FavoriteActiveBtn}
              </Button>
            )}

            {isSportTalkPreview
              && sportTalkPreview.sportTalkPreviewType === SPORT_TALK_PREVIEW_TYPE.ISSUE && (
                <SportTalkIssuePreview
                  isGray={pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER}
                  sportIssue={sportTalkPreview.sportIssue}
                  onClick={showSportTalkInMatchDetail}/>
              )}

          </div>
        </div>
      )
      panelChildren.push(matchGroup)
      matchCount += 1
    }

    return panelChildren
  }

  makeMatchBlockClassName = () => {
    const { id } = this.track
    return `MatchBlock_Block_${id}`
  }

  calculateBannerPosition = (
    pageType: PAGE_TYPE,
    globalBannerOrder: number,
    tournamentMatchInfos: FlatTournamentMatchInfo[],
  ): BANNER_POSITION_TYPE => {
    const isLeagueFilter = pageType === PAGE_TYPE.MATCHUP_FILTER || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
    const isFavoriteMatch = this.matchupStore.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH
    const isMyBetMatch = this.matchupStore.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.MY_BET_MATCH
    let bannerPosition: BANNER_POSITION_TYPE
    let tournamentMatchInfosLength = 0
    let bannerOrderInfo: FlatTournamentMatchInfo
    const pageSize = 20
    const isScrollingBannerLess = tournamentMatchInfosLength % pageSize === 0 && this.matchupStore.hasMore

    if (tournamentMatchInfos) {
      tournamentMatchInfosLength = tournamentMatchInfos.length
      bannerOrderInfo = tournamentMatchInfos[globalBannerOrder - 1]
    }

    if (isLeagueFilter || isFavoriteMatch || isMyBetMatch) {
      if (isScrollingBannerLess) {
        bannerPosition = BANNER_POSITION_TYPE.NONE
      } else {
        bannerPosition = BANNER_POSITION_TYPE.BOTTOM
      }
    } else {
      if (globalBannerOrder === TOP_BANNER_ORDER) {
        bannerPosition = BANNER_POSITION_TYPE.TOP
      } else if (bannerOrderInfo) {
        bannerPosition = BANNER_POSITION_TYPE.MIDDLE
      } else if (isScrollingBannerLess) {
        bannerPosition = BANNER_POSITION_TYPE.NONE
      } else if (tournamentMatchInfosLength < globalBannerOrder) {
        bannerPosition = BANNER_POSITION_TYPE.BOTTOM
      } else {
        bannerPosition = BANNER_POSITION_TYPE.NONE
      }
    }

    return bannerPosition
  }

  getBannerVisibility = (
    pageType: PAGE_TYPE,
    visibleBanner: boolean,
    rowIndex: string,
  ) => {
    const isLeagueFilter = pageType === PAGE_TYPE.MATCHUP_FILTER || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
    const tournamentMatchInfos: FlatTournamentMatchInfo[]
      = isLeagueFilter
      ? this.matchupStore.flatLeagueFilterTournamentTrackMatchInfos
      : this.matchupStore.flatTournamentTrackMatchInfos
    const globalBannerOrder: number = this.globalStore.getMatchListBannerOrder()
    const currentRowIndex = _.toNumber(rowIndex)

    let bannerRowIndex = 0
    let lastMatchRowIndex = 0
    if (tournamentMatchInfos) {
      // 매치 순번을 찾기 위한 인덱스 계산
      bannerRowIndex = tournamentMatchInfos[globalBannerOrder - 1]?.tournamentIndex

      // 리그 마지막 매치 인덱스 계산 => 지정된 배너 순번이 리그 중간에 위치한 경우 리그 마지막 매치 하단에 배너 위치
      lastMatchRowIndex = tournamentMatchInfos[tournamentMatchInfos.length - 1]?.tournamentIndex
    }

    // 배너 위치 지정('top', 'middle', 'bottom')
    const bannerPosition: BANNER_POSITION_TYPE
      = this.calculateBannerPosition(pageType, globalBannerOrder, tournamentMatchInfos)

    return {
      isTopBannerVisible:
        visibleBanner && bannerPosition === BANNER_POSITION_TYPE.TOP && currentRowIndex === TOP_BANNER_ORDER,
      isMiddleBannerVisible:
        visibleBanner && bannerPosition === BANNER_POSITION_TYPE.MIDDLE && currentRowIndex === bannerRowIndex,
      isBottomBannerVisible:
        visibleBanner && bannerPosition === BANNER_POSITION_TYPE.BOTTOM && currentRowIndex === lastMatchRowIndex,
    }
  }

  render() {
    const { pageType, gameType, visibleBanner, rowIndex } = this.props
    const uKey = this.makeMatchBlockClassName()
    const matchBlockChildren = this.makeMatchBlockChildren()
    if (matchBlockChildren.length === 0) {
      return null
    }

    const className = classNames('', {
      'pc': !isMobile,
      'matchup-result': pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER,
    })

    let isTopBannerVisible = false
    let isMiddleBannerVisible = false
    let isBottomBannerVisible = false

    if (gameType !== GAME_TYPE.LIVE) {
      const visibility = this.getBannerVisibility(pageType, visibleBanner, rowIndex)
      isTopBannerVisible = visibility.isTopBannerVisible
      isMiddleBannerVisible = visibility.isMiddleBannerVisible
      isBottomBannerVisible = visibility.isBottomBannerVisible
    }

    return (
      <MatchWrapper id={uKey} key={uKey} className={className}>
        {/*{매치리스트 상단 배너}*/}
        {isTopBannerVisible && this.makeBanner()}

        <div className="match-block-header">
          {this.makeHeader()}
        </div>
        <div className={gameType === GAME_TYPE.LIVE ? 'match-block-body live' : 'match-block-body'}>
          {matchBlockChildren}
        </div>
        {/*{지정된 매치 순번에 보이는 배너}*/}
        {isMiddleBannerVisible && this.makeBanner()}

        {/*{매치리스트 하단 배너}*/}
        {isBottomBannerVisible && this.makeBanner()}
      </MatchWrapper>
    )
  }
}

export default observer(MatchBlock)
